import { DataEntries, entries } from '@components/sign-in-button/data'
import classNames from 'classnames'
import { useAuth } from 'context/auth/auth-context'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'
import styles from './styles.module.scss'

export const SideBarMenu: React.FC = () => {
  const { signOut, hasPermission } = useAuth()
  const [menus, setMenus] = useState<DataEntries[]>()

  const router = useRouter()

  const collapseMenu = (): DataEntries[] => {
    const menus = entries()

    return menus.map(menu => {
      if (menu.dataEntries) {
        menu.collapse = menu.dataEntries.some(menu =>
          router.pathname.includes(menu?.to)
        )
      }
      return menu
    })
  }

  useEffect(() => {
    setMenus(collapseMenu())
  }, [])

  const handleMenu = (menu: DataEntries): void => {
    setMenus(_menus => [
      ..._menus.map(_menu =>
        _menu !== menu ? _menu : { ...menu, collapse: !menu.collapse }
      )
    ])
  }

  return (
    <div className="flex flex-col bg-gray-100 shadow-sm p-6">
      <ul className="group-hover:block">
        {menus?.map(
          entry =>
            (!entry.roles || hasPermission(entry.roles)) && (
              <li
                key={entry.label}
                className="pb-2"
                onClick={() => entry.dataEntries && handleMenu(entry)}
              >
                <Link
                  href={entry?.to || '#'}
                  className={classNames(
                    'font-fira hover:text-orange text-base text-gray-700 w-full flex justify-between items-center',
                    {
                      'font-bold text-gray-900': router.pathname.includes(
                        entry?.to
                      )
                    }
                  )}
                >
                  {entry.label}
                  {entry.dataEntries && (
                    <div
                      className={
                        entry.collapse ? styles.rotate : 'transition-transform'
                      }
                    >
                      <IoIosArrowDown />
                    </div>
                  )}
                </Link>
                {entry.dataEntries && (
                  <ul
                    className={`transition-transform group-hover:block pl-5 ${
                      entry.collapse ? 'block' : 'hidden'
                    }`}
                  >
                    {entry.dataEntries.map(
                      submenu =>
                        (!submenu.roles || hasPermission(submenu.roles)) && (
                          <li key={submenu.label} className="pb-1">
                            <Link
                              href={submenu.to || '#'}
                              className={classNames(
                                'font-fira hover:text-orange text-base text-gray-700 w-full flex justify-between items-center',
                                {
                                  'font-bold text-gray-900':
                                    router.pathname.includes(submenu?.to)
                                }
                              )}
                            >
                              {submenu.label}
                            </Link>
                          </li>
                        )
                    )}
                  </ul>
                )}
              </li>
            )
        )}
        <li
          className="pb-4 font-fira hover:text-orange text-base text-gray-700 cursor-pointer p-0"
          onClick={() => signOut()}
        >
          Sair
        </li>
      </ul>
    </div>
  )
}
